export default __webpack_public_path__ + "static/media/hexagon-frame.1c14c63e.svg";